import Posts from '@/components/posts/Posts'
import PostMaintenance from '@/components/posts/Maintenance'
import { i18n } from '@/plugins/i18n'

let routes = [
    {
        path: '/posts',
        name: 'posts',
        component: Posts,
        meta: {
            title: i18n.tc('posts.post', 2),
            requiresAuth: true,
            authorize: ['ADMIN']
        }
    },
    {
        path: '/posts/new',
        name: 'add-post',
        component: PostMaintenance,
        meta: {
            title: i18n.tc('actions.add') + ' ' + i18n.tc('posts.post', 1),
            requiresAuth: true,
            authorize: ['ADMIN']
        }
    },
    {
        path: '/posts/:id/edit',
        name: 'edit-post',
        component: PostMaintenance,
        meta: {
            title: i18n.tc('actions.edit') + ' ' + i18n.tc('posts.post', 1),
            requiresAuth: true,
            authorize: ['ADMIN']
        }
    }
]
export default routes
